import { createAction } from '@'
import { $formValues } from '../stores'

export default createAction('GetFormValues', name => {
    return $formValues.subStore(name).getState()
})
